import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill", "data-test"]

import { computed } from "vue";

interface Props {
  index: number;
  hoverRating: number;
  rating: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Star',
  props: {
    index: {},
    hoverRating: {},
    rating: {}
  },
  emits: ["setHoverRating"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isActive = computed<boolean>(() => {
  return (
    props.index <= props.hoverRating ||
    (props.hoverRating === 0 && props.index <= props.rating)
  );
});

function setHoverRating() {
  emit("setHoverRating", { index: props.index});
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    id: "svgelem",
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    onMouseover: setHoverRating
  }, [
    _createElementVNode("polygon", {
      points: "19.8, 2.2, 6.6, 43.56, 39.6, 17.16, 0, 17.16, 33, 43.56",
      fill: isActive.value ? '#ffd055' : '#d8d8d8',
      "data-test": isActive.value
    }, null, 8, _hoisted_1)
  ], 32))
}
}

})